import * as React from "react"
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area"

import { cn } from "@/lib/utils"

/* `viewportRef` wijst het element aan dat ECHT scrolt.
 *
 * De `ref` hierboven gaat naar de Root, en die scrolt niet: Radix zet de
 * overflow op de Viewport eronder. Wie de scrollpositie wil weten heeft dus
 * een tweede ingang nodig.
 *
 * **WAAROM EEN PROP EN NIET `querySelector` OP HET DATA-ATTRIBUUT VAN RADIX.**
 * Dat attribuut is een NAAM, en een verwijzing op een naam breekt STIL zodra
 * die naam bij een volgende versie verandert: er komt geen fout, er komt
 * `null`, en dan scrolt het scherm nooit meer mee zonder dat er iets afgaat.
 * Een prop is een afspraak tussen deze twee bestanden en verandert alleen
 * als wij hem veranderen.
 */
const ScrollArea = React.forwardRef(({ className, children, viewportRef, ...props }, ref) => (
  <ScrollAreaPrimitive.Root
    ref={ref}
    className={cn("relative overflow-hidden", className)}
    {...props}>
    <ScrollAreaPrimitive.Viewport ref={viewportRef} className="h-full w-full rounded-[inherit]">
      {children}
    </ScrollAreaPrimitive.Viewport>
    <ScrollBar />
    <ScrollAreaPrimitive.Corner />
  </ScrollAreaPrimitive.Root>
))
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName

const ScrollBar = React.forwardRef(({ className, orientation = "vertical", ...props }, ref) => (
  <ScrollAreaPrimitive.ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    className={cn(
      "flex touch-none select-none transition-colors",
      orientation === "vertical" &&
        "h-full w-2.5 border-l border-l-transparent p-[1px]",
      orientation === "horizontal" &&
        "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      className
    )}
    {...props}>
    <ScrollAreaPrimitive.ScrollAreaThumb className="relative flex-1 rounded-full bg-border" />
  </ScrollAreaPrimitive.ScrollAreaScrollbar>
))
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName

export { ScrollArea, ScrollBar }
